module.exports = __webpack_public_path__ + "static/img/weather-bg-1.24c2938.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather/weather-bg-1.gif
// module id = Bi+1
// module chunks = 1